import { LoadingSkeleton as AuditTrailLoadingSkeleton, useAuditTrail } from '~/features/audit-trail'
import { PDFLoadingSkeleton } from '~/shared/ui'
import { LoadingSkeleton as ReviewFormLoadingSkeleton } from './review-form/loading-skeleton'

export function LoadingSkeleton({ loader }: { loader?: React.ReactNode }) {
  const { isAuditTrailVisible } = useAuditTrail()
  return (
    <div className="flex h-full w-full overflow-hidden">
      <div className="h-full max-w-full min-w-0 grow overflow-hidden">
        <PDFLoadingSkeleton variant="document" />
      </div>
      <div className="border-divider h-full w-[830px] shrink-0 border-l">
        <ReviewFormLoadingSkeleton loader={loader} />
      </div>
      {isAuditTrailVisible && <AuditTrailLoadingSkeleton />}
    </div>
  )
}
